import { schema } from 'normalizr'

export const ENTITY_QBO_ERRORS = 'quickbooksOnlineErrors'
export const ENTITY_QBO_ERRORS_LIST = 'quickbooksOnlineErrorsList'
export const QBO_ERRORS_COUNT_NAMESPACE = 'quickbooksOnlineErrorsCount'

export const qboErrorsSchema = new schema.Entity(ENTITY_QBO_ERRORS)
export const qboErrorsListSchema = new schema.Entity(
  ENTITY_QBO_ERRORS_LIST,
  { data: [qboErrorsSchema] },
  { idAttribute: () => 'list' }
)
